module.exports = __webpack_public_path__ + "static/media/hoodie.d20347a3.jpeg";